import { Box, Button, IconButton, Typography } from "@mui/material";
import CloseRounded from "@mui/icons-material/CloseRounded";
import FilterAltRounded from "@mui/icons-material/FilterAltRounded";
import { black, greyEnabled, purple, purpleLight } from "../../../../theme/colors";

export function FilterDialogHeader({
  title,
  onClose,
  onReset,
}: {
  title: string;
  onClose: () => void;
  onReset: () => void;
}) {
  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" px={2} pt={2}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 36,
              height: 36,
              borderRadius: 2,
              bgcolor: purpleLight,
              flexShrink: 0,
            }}
          >
            <FilterAltRounded sx={{ color: purple, fontSize: 20 }} />
          </Box>
          <Typography fontWeight={700} fontSize={17} color={black}>
            {title}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" sx={{ "&:hover": { bgcolor: purpleLight } }}>
          <CloseRounded fontSize="small" sx={{ color: "#5B4A5A" }} />
        </IconButton>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" px={2} pt={1.5} pb={1}>
        <Typography
          fontSize={12}
          fontWeight={700}
          color={greyEnabled}
          sx={{ textTransform: "uppercase", letterSpacing: 0.4 }}
        >
          Filter by
        </Typography>
        <Button
          variant="text"
          onClick={onReset}
          sx={{
            p: 0,
            minWidth: 0,
            textTransform: "none",
            fontWeight: 600,
            color: purple,
            "&:hover": { bgcolor: "transparent", textDecoration: "underline" },
          }}
        >
          Reset all
        </Button>
      </Box>
    </Box>
  );
}

export function FilterDialogFooter({
  onCancel,
  onApply,
  applyLabel = "Apply Filters",
}: {
  onCancel: () => void;
  onApply: () => void;
  applyLabel?: string;
}) {
  return (
    <Box mt={2} display="flex" gap={1.5}>
      <Button
        fullWidth
        variant="outlined"
        onClick={onCancel}
        sx={{
          borderColor: purple,
          color: purple,
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          "&:hover": { borderColor: purple, bgcolor: purpleLight },
        }}
      >
        Cancel
      </Button>
      <Button
        fullWidth
        variant="contained"
        disableElevation
        onClick={onApply}
        sx={{
          bgcolor: purple,
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          "&:hover": { bgcolor: "#7A2074" },
        }}
      >
        {applyLabel}
      </Button>
    </Box>
  );
}

export function PillToggleButton({
  label,
  active,
  onClick,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <Button
      onClick={onClick}
      variant={active ? "contained" : "outlined"}
      disableElevation
      size="small"
      sx={{
        mr: 1,
        mb: 1,
        borderRadius: 5,
        textTransform: "none",
        fontWeight: 600,
        ...(active
          ? { bgcolor: purple, "&:hover": { bgcolor: "#7A2074" } }
          : {
              borderColor: "#ECECEC",
              color: black,
              "&:hover": { borderColor: purple, bgcolor: purpleLight },
            }),
      }}
    >
      {label}
    </Button>
  );
}
